var _defs, _path, _rect, _rect2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcoFriendly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eco-friendly",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.321,
    height: 119.321,
    viewBox: "0 0 119.321 119.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -1.768,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05abe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1cd89c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M25.864,69.863V82.79h3.977V68.869a1.989,1.989,0,0,0-.8-1.591L7.015,50.756,8.274,49.5,26.829,60.634a1.989,1.989,0,0,0,1.024.28H47.74a1.989,1.989,0,0,0,1.024-.284L67.318,49.493l1.259,1.259L46.546,67.278a1.989,1.989,0,0,0-.8,1.591V82.79h3.977V69.863L61.66,60.914l11.932,8.949V82.79H77.57V68.869a1.989,1.989,0,0,0-.8-1.591l-11.8-8.85L67.6,56.459l6.96,4.176a1.989,1.989,0,0,0,1.02.278H95.468a1.989,1.989,0,0,0,1.024-.284l18.554-11.137,1.259,1.259L94.275,67.278a1.989,1.989,0,0,0-.8,1.591V82.79h3.977V69.863l23.069-17.3a1.989,1.989,0,0,0,.213-3l-3.977-3.977a1.989,1.989,0,0,0-2.43-.3L94.917,56.937H91.081a8.949,8.949,0,1,0-11.113,0H76.132l-5.1-3.055,1.76-1.32a1.989,1.989,0,0,0,.213-3l-3.977-3.977a1.989,1.989,0,0,0-2.43-.3L61.66,48.254l-4.942-2.965a1.989,1.989,0,0,0-2.43.3l-3.977,3.977a1.989,1.989,0,0,0,.213,3l1.758,1.326-5.093,3.049H43.353a8.949,8.949,0,1,0-11.113,0H28.4L8.99,45.289a1.989,1.989,0,0,0-2.43.3L2.583,49.565a1.989,1.989,0,0,0,.213,3ZM85.525,45a4.972,4.972,0,1,1-4.972,4.972A4.972,4.972,0,0,1,85.525,45ZM56,49.5l1.79,1.076-1.838,1.1L54.74,50.76ZM37.8,45a4.972,4.972,0,1,1-4.972,4.972A4.972,4.972,0,0,1,37.8,45Z",
    transform: "translate(-2 36.531)",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 3,
    height: 4,
    transform: "translate(58.113 67.566)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 3,
    height: 4,
    transform: "translate(58.113 75.566)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M47.819,65.638A31.819,31.819,0,1,0,16,33.819,31.819,31.819,0,0,0,47.819,65.638Zm0-59.661A27.842,27.842,0,1,1,19.977,33.819,27.842,27.842,0,0,1,47.819,5.977Z",
    transform: "translate(11.841 -2)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M41.872,40.784c.4,0,.772,0,1.122-.02h.4c4.86,0,12.01-.895,16.691-5.487,7.533-7.39,5.338-21.024,5.24-21.6a1.989,1.989,0,0,0-1.643-1.635c-.6-.091-14.444-2.241-21.955,5.125a15.346,15.346,0,0,0-1.754,2.106c-6.748-5.155-16.944-4.021-17.4-3.965a1.989,1.989,0,0,0-1.74,1.73c-.058.485-1.392,11.932,5.254,18.471C30.662,39.982,37.563,40.784,41.872,40.784Zm2.643-20.772c4.815-4.725,13.583-4.5,17.059-4.2.3,3.415.511,11.944-4.274,16.635-3.812,3.739-10.093,4.375-14.273,4.333L55.413,24.63l-2.784-2.84L40.1,34.068C40.053,29.987,40.681,23.771,44.515,20.012ZM24.68,19.165c2.983-.088,9.307.237,13.34,3.7a24.262,24.262,0,0,0-1.44,5.147l-4.574-4.5-2.784,2.84,6.917,6.783c-.014,1.163.022,2.221.082,3.086a14.78,14.78,0,0,1-7.338-3.55c-3.952-3.878-4.282-10.46-4.2-13.507Z",
    transform: "translate(16.47 7.571)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoFriendly);
export default __webpack_public_path__ + "static/media/eco-friendly.7567b1d9cb3f0a73f719c2a4e0074061.svg";
export { ForwardRef as ReactComponent };